<template>
    <Chart type="horizontal" :chartdata="data" :options="options"></Chart>
</template>
<script>
import db from '@/components/firebase.init'
import Chart from '@/components/charts/Charts'
export default {
    data(){
        return{
            options: {
                         tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  },
                scales: {
                    yAxes: [{
                        maxBarThickness: '50',
                        // barThickness: '30',
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                },
                animation: {
                easing: 'easeOutBounce',
                numSteps: '100',
                },
                hover: {
                    animationDuration: '1',
                },
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },
            },
            data:{
                labels: [],
                datasets: []
            },
            chartArray: [],
            ids:[]
        }
    },
    methods:{
        getChartData(){
          var docRef = db.collection("overallAnalytics").doc("widgetFive");
              docRef.get()
            .then((doc) => {
                const data = doc.data();
             
                    if(data.Finance != null){
                   this.chartArray[0] = data.Finance;
                }

          if(data.HumanResource != null){
                    this.chartArray[1] = data.HumanResource;
                }
                   if(data.InformationTechnology != null){
                    this.chartArray[2] = data.InformationTechnology;
                }

      if(data.Operation != null){
                    this.chartArray[3] = data.Operation;
                }
                      if(data.ResearchandDevelopment != null){
                    this.chartArray[4] = data.ResearchandDevelopment;
                }
     if(data.SalesandMarketing != null){
                    this.chartArray[5] = data.SalesandMarketing;
                }
                   if(data.Production != null){
                    this.chartArray[6] = data.Production;
                }
      if(data.Logistic != null){
                    this.chartArray[7] = data.Logistic;
                }
                    if(data.CustomerSupport != null){
                    this.chartArray[8] = data.CustomerSupport;
                }
                      if(data.ProcurementandPurchasing != null){
                    this.chartArray[9] = data.ProcurementandPurchasing;
                }
           if(data.Engineering != null){
                    this.chartArray[10] = data.Engineering;
                }
                    if(data.GroundCrew != null){
                    this.chartArray[11] = data.GroundCrew;
                }
  if(data.Aviation != null){
                    this.chartArray[12] = data.Aviation;
                }
                  if(data.TechnicalSupport != null){
                    this.chartArray[13] = data.TechnicalSupport;
                }
                          if(data.CabinCrew!= null){
                    this.chartArray[14] = data.CabinCrew;
                }
                       if(data.Others!= null){
                    this.chartArray[15] = data.Others;
                       }
            
             
            
                this.loadChart();
            })

            .catch(err => {
                console.log('Error getting documents', err);
            });
        },
        loadChart(){
            this.data = {
               labels: ['Finance','HumanResource','InformationTechnology','Operation','ResearchandDevelopment','SalesandMarketing','Production','Logistic','CustomerSupport','ProcurementandPurchasing','Engineering','Ground Crew','Aviation','TechnicalSupport','CabinCrew','Others'],
                datasets: [{
                    data: this.chartArray,
                    backgroundColor: [
                        '#13cc43', 
                        '#f8b229', 
                        '#bb2528', 
                        'purple',
                        'teal',
                        'indigo',
                        '#13cc43', 
                        '#f8b229', 
                        '#bb2528', 
                        'purple',
                        'teal',
                        'indigo',
                        '#13cc43', 
                        '#f8b229', 
                        '#bb2528', 
                        'purple',
                        'teal',
                        'indigo',
                        '#13cc43', 
                        '#f8b229', 
                        '#bb2528', 
                        'purple',
                        'teal',
                        'indigo',
                        ],
                            fill : true,
                            pointBackgroundColor: [
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                            ],
                            borderColor: 'white',
                            pointBorderColor: [
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                            ],
                            pointRadius: '5',
                            pointHitRadius: '6',
                            // pointBackgroundColor: 'rand',
                            borderWidth: '1',
                            pointBorderWidth: '3',
                }]
                
            }
                console.log(this.chartArray);
            }
        },
    components: {
        Chart
    },
    beforeMount(){
        this.getChartData()
    }
}
</script>

